import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  const messages: LocaleMessages = {};
  locales.keys().forEach((key: string) => {
    const matched = key.match(/([A-Za-z0-9-_,\s]+)\./i);
    if (matched && matched.length > 1) {
      // match file names
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

// change to use Japanese as default
// then decided by :lang on URL
let targetLang: string = "ja-JP";

export default new VueI18n({
  locale: targetLang, // set from browser language
  fallbackLocale: "ja-JP",
  messages: loadLocaleMessages(), // load from file
  silentFallbackWarn: true,
});
